import { CURRENCY_CONFIGS, SLIDER_CONFIGS } from '../constants';
import { type AppAction, type CurrencyKey, type SliderInput } from '../types';
import styles from './CalculatorInput.module.scss';
import CurrencyToggle from './CurrencyToggle';
import RangeSlider from './RangeSlider';

interface CalculatorInputProps {
  inputs: SliderInput;
  currency: CurrencyKey;
  dispatch: React.Dispatch<AppAction>;
}

function formatDisplayValue(
  value: number,
  format: 'number' | 'percent' | 'currency',
  currency: CurrencyKey,
): string {
  const { symbol } = CURRENCY_CONFIGS[currency];
  switch (format) {
    case 'number':
      return value.toLocaleString();
    case 'percent':
      return `${value}%`;
    case 'currency':
      return `${symbol}${value.toLocaleString()}`;
  }
}

export default function CalculatorInput({ inputs, currency, dispatch }: CalculatorInputProps) {
  return (
    <div className={styles.calculator}>
      <div className={styles.sliders}>
        {SLIDER_CONFIGS.map((config) => (
          <RangeSlider
            key={config.field}
            label={config.label}
            value={inputs[config.field]}
            min={config.min}
            max={config.max}
            step={config.step}
            displayValue={formatDisplayValue(inputs[config.field], config.format, currency)}
            onChange={(val) => dispatch({ type: 'SET_INPUT', field: config.field, value: val })}
          />
        ))}
      </div>
      <div className={styles.bottom}>
        <button
          type="button"
          className="interact-button button--primary button--medium"
          onClick={() => dispatch({ type: 'CALCULATE' })}
        >
          <span className="button__content">
            Calculate
            <span className="button__icon" aria-hidden="true">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path
                  d="M9 18l6-6-6-6"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          </span>
        </button>
        <CurrencyToggle
          value={currency}
          onChange={(c) => dispatch({ type: 'SET_CURRENCY', currency: c })}
        />
      </div>
    </div>
  );
}
